module.exports = __webpack_public_path__ + "static/img/error.b12ad2ea.png";